import React, { Component } from "react";
import { config } from "../../config/general.config";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectDistributionDestination extends Component {
  initState = {
    dataOption: config.enum_distribution_destination,
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Distribution Destination" className="col-lg-12 my-1 py-1">
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder="Select Destination" value={this.props.value} onChange={this.props.onChangeValue} mode={this.props.mode}>
          {Object.entries(this.state.dataOption).map(([key, value]) => {
            return (
              <Option key={key} value={key}>
                {value?.toString()?.toUpperCase()}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default SelectDistributionDestination;
